export default __webpack_public_path__ + "static/media/validating-ticket.ae376059.svg";